// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Rbow","calendarButtons":"ClockData_calendarButtons__2oKTJ"};